<template>
  <transition name="modalbase" @after-leave="onAfterLeave">
    <div
      class="basic-modal-base"
      v-if="isOpenBasicModal"
      :class="{open: isOpenBasicModal}"
      :style="{ cursor: this.basicModalInfo.enableBgClick ? 'pointer' : 'default' }"
      @click.stop="onBgClick"
    >
      <div class="dialog-frame">
        <span class="outer-close-btn" @click.stop="onCloseClick"><span></span></span>
        <div
          class="dialog-body"
          v-html="dialogBody"
          @click.stop="onBodyClick"
          :style="{
            cursor: !!this.basicModalInfo.on && !!this.basicModalInfo.on.bodyClick ? 'pointer' : 'default'
          }"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapState} from 'vuex'
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'BasicModal',
  computed: {
    ...mapState({
      isOpenBasicModal: states => states.uiState.isOpenBasicModal,
      basicModalInfo: states => states.uiState.basicModalInfo,
    }),
    hasOuterCloseBtn() {
      return true
    },
    dialogBody() {
      return this.basicModalInfo.dialogBody
    }
  },
  watch: {
    isOpenBasicModal(val) {
      if(val){
        if(!!this.basicModalInfo.on && !!this.basicModalInfo.on.onModalShow) {
          this.basicModalInfo.on.onModalShow(this.basicModalInfo.addionalData)
        }
      }
    },
  },
  methods: {
    onBodyClick() {
      if(!!this.basicModalInfo.on && !!this.basicModalInfo.on.bodyClick) {
        this.basicModalInfo.on.bodyClick()
        this.onCloseClick(true)
      }
    },
    onBgClick() {
      if(this.basicModalInfo.enableBgClick) {
        this.onCloseClick()
      }
    },
    onCloseClick(noProc) {
      if(!!this.basicModalInfo.on && !!this.basicModalInfo.on.closeClick && !noProc) {
        this.basicModalInfo.on.closeClick(this.basicModalInfo.addionalData)
      }
      this.$store.dispatch(type.CLOSE_BASIC_MODAL)
    },
    onAfterLeave() {
      if(!!this.basicModalInfo.on && !!this.basicModalInfo.on.afterLeave) {
        this.basicModalInfo.on.afterLeave(this.basicModalInfo.addionalData)
      }
    },
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.basic-modal-base {
  background: rgba(0,0,0,0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
  display: flex;
  justify-content: center;
  align-items: center;
  .dialog-frame {
    width: 100%;
    height: auto;
    max-width: 556px;
    position: relative;
  }
}

.outer-close-btn {
  $btn_width: 20px;
  $btn_color: white;
  position: absolute;
  width: $btn_width;
  height: $btn_width;
  top: -($btn_width * 1.24);
  right: 4px;
  display: block;
  & > span {
    width: 100%;
    height: 100%;
    position: relative;
    display: block;
    &::before,
    &::after {
      content: "";
      display: block;
      width: 100%;
      height: 2px;
      border-radius: 2px;
      background: $btn_color;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }
    &::before {
      transform: rotate(-45deg);
    }
    &::after {
      transform: rotate(45deg);
    }
  }
}

/deep/ .dialog-body {
  img {
    display: block;
    max-width: 100%;
  }
}

.modalbase {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out 0s;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
  &-enter-to, &-leave {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/BasicModal.vue